module.exports = __webpack_public_path__ + "static/media/Stellar Ark Queen Headboard - 155 cm_Cream.4d61ed66.png";